import { Grid } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import AppLoaderPage from '../../../app/features/loader/page/AppLoaderPage';
import useNewsArticles from '../hooks/useNewsArticles';
import INewsArticle from '../interfaces/INewsArticle';
import CNewsArticle from '../components/CNewsArticle';

const VNewsArticleList = () => {
	const { data: news } = useNewsArticles();

	const [newsFiltered, setNewsFiltered] = useState<INewsArticle[] | null>(null);
	useEffect(() => {
		if (news) {
			setNewsFiltered(_.orderBy(news, ['creation'], ['desc']));
		} else {
			setNewsFiltered(null);
		}
	}, [news]);
	return (
		<>
			{newsFiltered ? (
				<>
					<Grid container spacing={3} justifyContent="flex-start" alignItems="center">
						{newsFiltered.map((newFiltered) => {
							return (
								<Grid item sm={12} key={newFiltered.id}>
									<CNewsArticle article={newFiltered} size="medium" />
								</Grid>
							);
						})}
					</Grid>
				</>
			) : (
				<AppLoaderPage />
			)}
		</>
	);
};

export default VNewsArticleList;
